<template>
  <q-btn
    flat
    dense
    size="0.7em"
    icon="mdi-eye-outline"
    @click="handlerView"
  >
    <q-tooltip>Clique aqui para visualizar o orgão emissor e suas ações</q-tooltip>
  </q-btn>
</template>

<script>
import { ROUTE_AGENCY_EDIT } from '../constants'

export default {
  props: {
    model: {
      required: true,
      type: Object
    }
  },

  methods: {
    handlerView () {
      this.$router.push({ name: ROUTE_AGENCY_EDIT, params: { id: this.model.id } })
    }
  }
}
</script>
